const rand = (min, max, acc = 0) =>
  Math.floor(Math.random() * (max - min + 1) * Math.pow(10, acc)) / Math.pow(10, acc) + min;

export default rand;
